<div class="surface-card shadow-1 p-1" style="position: relative">
  <!-- Map container: always present to avoid ViewChild undefined problems -->
  <div class="map-wrapper" style="position: relative; width: 100%">
    <div #mapContainer [style.height]="height" style="width: 100%"></div>

    <!-- overlay spinner while loading map or data -->
    <div
      *ngIf="!mapReady || dataLoading || externalLoading"
      class="map-overlay-spinner"
      style="
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgb(194, 194, 194);
        z-index: 9999;
      "
    >
      <div class="loading-content" style="text-align: center">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: var(--primary-color)"></i>
        <p class="mt-3 text-600">Loading map...</p>
        <p class="text-sm text-500 mt-2" *ngIf="!mapReady">Waiting for Google Maps API</p>
        <p class="text-sm text-500 mt-2" *ngIf="mapReady && (dataLoading || externalLoading)">
          Loading map data...
        </p>
      </div>
    </div>

    <!-- Map Legend -->
    <!-- <div *ngIf="legendItems.length" class="map-legend">
      <div class="legend-title">
        <i class="pi pi-info-circle"></i>
        <span>Map Legend</span>
      </div>
      <div class="legend-items">
        <div *ngFor="let item of legendItems" class="legend-item">
          <div class="legend-marker" [ngStyle]="{'background-color': item.color}"></div>
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div> -->
  </div>
</div>
